import template from '../directive/availabilityStyle.html';

const availabilityStyle: angular.IDirectiveFactory = () => ({
  scope: {
    availability: '=',
    label: '=',
  },
  template,
});

export default availabilityStyle;
